import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Login", -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1)

import { inject, ref } from 'vue'
import router from '@/router'
import store from '@/store'


export default {
  __name: 'LoginView',
  props: ['next'],
  setup(__props) {

const props = __props;



const axios = inject('axios')
const username = ref('')
const password = ref('')

function login () {
  axios.post('/api/login', {
    username: username.value,
    password: password.value
  }).then(res => {
    if (res.data.status) {
      store.isLogged = true
      store.isModo = res.data.isModo
      router.push(props.next ?? '/')
    } else {
      alert('Login failed')
    }
  })
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _withModifiers(login, ["prevent"])
    }, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "username",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((username).value = $event))
      }, null, 512), [
        [_vModelText, username.value]
      ]),
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "password",
        id: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((password).value = $event))
      }, null, 512), [
        [_vModelText, password.value]
      ]),
      _createElementVNode("button", {
        type: "submit",
        onClick: login
      }, "Login")
    ], 40, _hoisted_2)
  ]))
}
}

}